import React, {useState, useEffect} from 'react'
import { MdFormatListBulleted } from 'react-icons/md';

const SiteEnquiry = () => {
      const [enquiry, setEnquiry] = useState([]);
          const [loading, setLoading] = useState(false);
          const [searchQuery, setSearchQuery] = useState('');


              useEffect(() => {
                  const fetchEnquiry = async () => {
                      setLoading(true);
                      try {
                          const response = await fetch('https://api.tradeintell.com/get-enquiry');
          
                          if (response.ok) {
                              const data = await response.json();
const sortedData = data.sort((a, b) => new Date(b.enquire_on) - new Date(a.enquire_on));
          
                              setEnquiry(sortedData);
                              setLoading(false);
                          } else {
                              setLoading(false);
                              console.error('Failed to fetch users');
                          }
                      } catch (error) {
                          setLoading(false);
                          console.error('Error fetching data:', error);
                      }
                  };
          
                  fetchEnquiry();
              }, []);
          
          
              const filterEnq = enquiry.filter(myItem =>
            (myItem.name?.toLowerCase().includes(searchQuery.toLowerCase()) || 
             myItem.mobile?.toLowerCase().includes(searchQuery.toLowerCase()))
          );

            const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

          

  return (
    <>
    <section className='my-4'>
    <div className='px-4'>

<p className='page-heading'>Site Enquiries</p>
<p className='para-text text-muted'>All customer enquiries submitted through the website are listed here for easy review and follow-up.
</p>

                        <div className='d-flex'>
                        <MdFormatListBulleted size={30} className='align-content-center' />
                        <input
                            type="text"
                            className="contact-control py-2"
                            placeholder="Search By Name, Mobile"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>


<div className='table-responsive mt-3'>
    <table className='w-100 table'>

        <thead>
            <tr>
                <th>S No</th>
                <th>Enquire On</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Message</th>
            </tr>
        </thead>

<tbody>
  {filterEnq.length > 0 ? (
    filterEnq.map((user, index) => (
      <tr key={user.id}>
        <td>{index + 1}</td>
        <td>{formatDate(user.enquire_on)}</td>
        <td>{user.name}</td>
        <td>{user.email}</td>
        <td>{user.mobile}</td>
        <td>{user.message || '-'}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">
        No users found.
      </td>
    </tr>
  )}
</tbody>


    </table>
</div>


</div>
</section>
    </>
  )
}

export default SiteEnquiry